export default {
  computed: {
    elementLogoComponent() {
      return `page-element-logo-${this.$store.getters['getModuleSetting']('theme', 'page-element-logo', '0001')}`
    }
  }
}
